export default __webpack_public_path__ + "static/media/CI3.6505b5e9.png";